import { render } from "./Lock.vue?vue&type=template&id=5ca3c328&scoped=true"
import script from "./Lock.vue?vue&type=script&lang=js"
export * from "./Lock.vue?vue&type=script&lang=js"

import "./Lock.vue?vue&type=style&index=0&id=5ca3c328&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca3c328"]])

export default __exports__